import mq from 'core/DOM/matchTablet'

export const MAX_PLANS_TO_COMPARE = mq.matches ? 3 : 2
export const MAX_PLANS_TO_COMPARE_NEW = 3
